<template>
    <div>
        <a @click.prevent="openPopup" class="remove-cross" href="#"></a>
        <confirm-delete-popup @confirm="submit" @cancel="closePopup" :message="$t('components.ConfirmDeletePopup.title')" :show="showConfirmPopup"></confirm-delete-popup>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                showConfirmPopup: false,
            };
        },
        methods: {
            openPopup() {
                this.showConfirmPopup = true;
            },
            submit() {
                this.closePopup();
                this.$emit('submit');
            },
            closePopup() {
                this.showConfirmPopup = false;
            },
        }
    };
</script>
